import { render, staticRenderFns } from "./AuthDialog.vue?vue&type=template&id=2095b0bc&"
import script from "./AuthDialog.vue?vue&type=script&lang=js&"
export * from "./AuthDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports